<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-title">
        <p class="title">Imágenes</p>
        <CloseButton @click="closeModal" />
      </div>
      <div class="wrapper-images">
        <PrevNextButton
          type="Prev"
          class="prev"
          :isDisabled="!countImages"
          @click="backSlider"
        />
        <img :src="currentImage" alt="" class="image" />
        <PrevNextButton
          type="Next"
          class="next"
          :isDisabled="!countImages"
          @click="nextSlider"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import CloseButton from "@/components/commons/controls/CloseButton.vue";
import PrevNextButton from "@/components/commons/controls/PrevNextButton.vue";

export default defineComponent({
  name: "ModalImages",
  components: {
    CloseButton,
    PrevNextButton,
  },
  props: {
    listImages: {
      type: Array as () => string[],
      required: true,
    },
  },

  setup(props, context) {
    const currentIndex = ref(0);

    const currentImage = computed(() => {
      if (props.listImages.length === 0) {
        return require("@/assets/images/ImageExample.png");
      }
      return props.listImages[currentIndex.value];
    });

    const countImages = computed(() => {
      return props.listImages.length > 1;
    });

    function closeModal() {
      context.emit("closeImages");
    }

    function backSlider() {
      if (!countImages.value) return;

      currentIndex.value =
        currentIndex.value === 0
          ? props.listImages.length - 1
          : currentIndex.value - 1;
    }

    function nextSlider() {
      if (!countImages.value) return;

      currentIndex.value =
        currentIndex.value === props.listImages.length - 1
          ? 0
          : currentIndex.value + 1;
    }

    return {
      closeModal,
      backSlider,
      nextSlider,
      currentImage,
      countImages,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedComponents/styles/modalImagesStyle";
</style>
